// extracted by mini-css-extract-plugin
module.exports = {"category-lock-checkbox":"CheckboxWrapper_category-lock-checkbox__bb_JP","category-lock-checkbox__input":"CheckboxWrapper_category-lock-checkbox__input__IsdVx"};